var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":"ニックネーム"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nickname),expression:"nickname"}],staticClass:"title_input",attrs:{"type":"text","placeholder":"ニックネーム"},domProps:{"value":(_vm.nickname)},on:{"input":function($event){if($event.target.composing)return;_vm.nickname=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }